<template>
    <div class="automation-trigger-settings">
        <p>{{ t('automations-form-triggers_config-quotation_expired-description') }}</p>
        <div class="field" >
            <div>
                <label
                    ><input type="radio" value="before" v-model="when" /> {{ t('automations-form-triggers_config-quotation_expired-when_options-before') }} </label
                >
                <label
                    ><input type="radio" value="after" v-model="when" /> {{ t('automations-form-triggers_config-quotation_expired-when_options-after') }}
                </label>
                <label
                    ><input type="radio" value="at_date" v-model="when" />
                    {{ t('automations-form-triggers_config-quotation_expired-when_options-at_date') }}
                </label>
            </div>
        </div>
        <div class="field" v-if="when && when !== 'at_date'">
            <label :class="{ label: true, 'label-danger': !isValidThreshold() }"
                >{{ t('automations-form-triggers_config-quotation_expired-threshold_label', [t('automations-form-triggers_config-quotation_expired-threshold_options-' + when)]) }}</label
            >
            <input
                type="tel"
                required
                pattern="[0-9]{0,3}"
                class="form-control"
                v-model="threshold"
            />
        </div>

    </div>
</template>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            threshold: this.getValue("threshold", null),
            field_id: this.getValue("field_id", ""),
            when: this.getValue("when", ""),
            custom_fields: [],
        };
    },
    mounted() {
        this.loadFields();
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    computed: {
        customDateFields() {
            if (this.custom_fields) {
                return this.custom_fields.filter(
                    (field) => field.type === "date",
                );
            }
            return [];
        },

    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        getValue(key, defaultValue) {
            return this.value[0] && this.value[0][key]
                ? this.value[0][key]
                : defaultValue;
        },
        isValidThreshold() {
            let regex = /^[0-9]{1,3}$/;
            if (this.when === "at_date") {
                return true;
            }
            if (regex.test(this.threshold) && this.when) {
                return true;
            }
        },
        isValid() {
            return this.isValidThreshold() && this.when;
        },
        changed: function () {
            this.$emit("input", [
                {
                    when: this.when,
                    yearly: this.yearly,
                    threshold: this.threshold,
                },
            ]);
        },
        loadFields() {
            const options = keviApi.getOptions("client-fields", "GET");
            return this.$http(options).then((response) => {
                this.custom_fields = response.body;
            });
        },
    },
    watch: {
        field_id() {
            this.changed();
        },
        yearly() {
            this.changed();
        },
        when() {
            if (this.when === "at_date") {
                this.threshold = 0;
            }
            this.changed();
        },
        threshold() {
            this.changed();
        },
        value() {
            const threshold = this.getValue("threshold", null);
            if (threshold !== this.threshold) {
                this.threshold = threshold;
            }
            const yearly = this.getValue("yearly", false);
            if (yearly !== this.yearly) {
                this.yearly = yearly;
            }
            const when = this.getValue("when", "");
            if (when !== this.when) {
                this.when = when;
            }
        },
    },
};
</script>
